<p>purchase-cost-variation-log works!</p>
